import { useQuery } from 'react-query';

import organizationApi from '@shared/api/organizationApi';

const getWebhookSecrets = async ({
  organizationId
}: {
  organizationId: string;
}) => {
  const {
    data
  }: {
    data: { secrets: string[] };
  } = await organizationApi.fetchWebhookSecrets(organizationId);
  return data;
};

const useWebhookSecrets = (organizationId: string) => {
  return useQuery(
    ['webhook-secrets', organizationId],
    () => getWebhookSecrets({ organizationId }),
    {
      enabled: !!organizationId,
      retry: false
    }
  );
};

export default useWebhookSecrets;
